import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ErrorPage from '../components/ErrorPage/ErrorPage';
import parseQueryParams from '../utils/parseQueryParams';
import { analytics } from '../utils/analytics';
import { getTeamsAuthToken } from '../utils/initTeamsJs';

import { authStart, authSuccess, authFail, authRefreshSuccess, authRefreshFail } from '../actions/authActions';
import startAccessTokenRefreshTimer from '../utils/startAccessTokenRefreshTimer';
import isAccessTokenExpired from '../utils/isTokenExpired';

require('../styles/layout.css')

const Layout = (props: any): ReactElement => {
  const dispatch = useDispatch();

  useEffect(() => {
    const queryParams = parseQueryParams(window?.location);
    analytics.instance.trackPageView(queryParams);

    // initialize team-js and get the access token
    const onAuthSuccess = (accessToken: string) => {
      dispatch(authSuccess(accessToken));

      // ApiServices uses the access token when fetching data from the BE, and 
      // it currently requires the token to be shared via the sessionStorage
      sessionStorage.setItem('accessToken', accessToken);
      startAccessTokenRefreshTimer(accessToken);
    }
    const onAuthFail = (error: Error) => dispatch(authFail(error));

    let accessToken = sessionStorage.getItem('accessToken');
    if(accessToken && !isAccessTokenExpired(accessToken)) {
      onAuthSuccess(accessToken);
    }
    else {
      dispatch(authStart());
      getTeamsAuthToken(onAuthSuccess, onAuthFail);
    }
  }, []);

  const getIsLoading = (state: any) => {
    return state?.authReducer?.isLoading;
  }

  const getAuthError = (state: any) => {
    return state?.authReducer?.error
  }

  const isLoading = useSelector(getIsLoading);
  const authError = useSelector(getAuthError);

  if (isLoading && !authError) {
    return <div>Loading...</div>
  }

  if (!isLoading && authError) {
    return <ErrorPage />
  }

  return <div className="root" {...props} />
};

export default Layout;